/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../../lib/config";
import { RootState } from "..";
import {
  mapExternalUsers,
  mapExternalUsersArray,
} from "../../hooks/useExternalUser";

const baseQueryWithUserMapping = async (
  args: any,
  api: any,
  extraOptions: any
) => {
  // First, execute the base query
  const result = await fetchBaseQuery({
    baseUrl: config.apiUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        const apikey = `${token}`;
        headers.set("apikey", apikey);
      }
      return headers;
    },
  })(args, api, extraOptions);

  // Check if we have an error
  if (result.error) {
    return result;
  }
  console.log("Base query result:", result);
  // If we have data and it might contain user references, process it
  if (result.data && mightContainUserRefs(result.data)) {
    const transformedData = Array.isArray(result.data)
      ? await mapExternalUsersArray(result.data)
      : await mapExternalUsers(result.data);

    return {
      ...result,
      data: transformedData,
    };
  }

  return result;
};

function mightContainUserRefs(obj: any): boolean {
  if (!obj || typeof obj !== "object") return false;

  // Check current level
  const hasUserRefsAtCurrentLevel = userRefPatterns.some((pattern) =>
    Object.keys(obj).includes(pattern)
  );

  if (hasUserRefsAtCurrentLevel) return true;

  // Recursively check all nested objects and arrays
  return Object.values(obj).some((value) => {
    if (Array.isArray(value)) {
      // Check each item in the array
      return value.some((item) => mightContainUserRefs(item));
    } else if (value && typeof value === "object") {
      // Recursively check nested objects
      return mightContainUserRefs(value);
    }
    return false;
  });
}

const userRefPatterns = [
  "CreatedById",
  "ChangedById",
  "AssignedToId",
  "ClosedById",
];

export const baseApi = createApi({
  reducerPath: "navApi",

  endpoints: () => ({}),
  tagTypes: [
    "User",
    "CurrentUser",
    "Calendar",
    "Reports",
    "Communications",
    "Timeline",
    "ContactPersons",
    "Opportunities",
    "MyOpportunities",
    "ProductTypeList",
    "ProductList",
    "Emails",
    "Leads",
    "Users",
    "NextAction",
    "Teams",
    "MyCustomer",
    "WorkItem",
    "ProspectSuspectList",
    "SalesEmployees",
    "Customer",
    "CustomerNote",
    "Work",
    "Workitems",
    "WorkItem",
    "MsDeltaKey",
    "Visits",
    "SalesManagerData",
    "CustomerGroup",
    "Employee",
    "MyContacts",
  ],
  baseQuery: baseQueryWithUserMapping,
});
